export default "__VITE_ASSET__032db256__"